import * as hangul from 'hangul-js'

function searchClientList(searchList, list, query) {
  if (hangul.isConsonantAll(query)) { // 한글 초성인경우
    query = hangul.disassemble(query).join("");
    searchList = []
    for (let i = 0; i < list.length; i++) {
      if (list[i].clientName && list[i].disassemble.includes(query)) {
        searchList.push(list[i])
      }
    }
  }
  else {
    searchList = []
    for (let j = 0; j < list.length; j++) {
      if (list[j].clientName && list[j].clientName.toLowerCase().includes(query) || list[j].clientCode && list[j].clientCode.includes(query) || list[j].agentName && list[j].agentName.toLowerCase().includes(query)) {
        searchList.push(list[j])
      }
    }
  }
  return searchList;
}

function addPropertyToClientListDataObjects(data) {
  for (let i = 0; i < data.length; i++) {
    let element = data[i]
    let dis = hangul.disassemble(element.clientName, true);
    let cho = "";
    for (let i = 0; i < dis.length; i++) {
      let elem = dis[i][0] ? dis[i][0] : dis[i];
      cho += elem;
    }
    // let cho = dis.reduce(function (prev, elem) {
    //   elem = elem[0] ? elem[0] : elem;
    //   return prev + elem;
    // }, "");
    data[i].disassemble = cho
  }
  return data;
}

function numberToKorean(number) {
  let inputNumber = number < 0 ? false : number
  let unitWords = ['', '만', '억', '조', '경']
  let splitUnit = 10000
  let splitCount = unitWords.length
  let resultArray = []
  let resultString = ''

  for (let i = 0; i < splitCount; i++) {
    let unitResult = (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i)
    unitResult = Math.floor(unitResult)
    if (unitResult > 0) {
      resultArray[i] = unitResult
    }
  }

  for (let j = 0; j < resultArray.length; j++) {
    if (!resultArray[j]) continue
    resultString = String(resultArray[j]) + unitWords[j] + resultString
  }

  return resultString + '원'
}

function formatRegistrationNumber(value) { // 사업자 등록번호 정규식
  const regex = /^(\d{3})(\d{2})(\d{5})$/
  return value.replace(regex, '$1-$2-$3')
}

function formatNumberToRegexPattern(number) {
  if (/^02/.test(number)) { // 서울 지역번호 형식
    return number.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
  } else if (/^01(0|1|6|7|8|9)/.test(number)) { // 휴대전화 형식
    return number.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3')
  } else if (/^0(3[1-3]|4[1-4]|5[1-5]|6[1-4]|7[0-9]|8[1-4])/.test(number)) { // 지방 지역번호 형식
    return number.replace(/(\d{2,3})(\d{3,4})(\d{4})/, '$1-$2-$3')
  } else { // 그 외의 경우
    // 예외 처리 등을 수행할 수 있습니다.
    return number
  }
}

function textWithLineBreaks(str) { // 정규식 <br/>로 변환
  let data = str
  if (typeof data === 'string') {
    data = data.replace(/\n/g, '<br>')
  }

  return data
}

function replaceCommasWithNewlines(inputString) { // 쉼표(,)를 개행문자로 변경
  return inputString.replace(/,/g, '\n')
}

function formatCelNumberToRegexPattern(number) {
  const regex = /^(?:(010-\d{4})|(01[1|6|7|8|9]-\d{3,4}))-(\d{4})$/
  return number.replace(regex, '0$1-$2-$3')
}

function formatDateTime(dateTimeString) { // 날짜 변환 함수
  const date = new Date(dateTimeString)

  // 월은 0부터 시작하므로 +1 해줌
  const month = date.getMonth() + 1
  const day = date.getDate()
  const year = date.getFullYear()

  let hours = date.getHours()
  let ampm = '오전'

  // 오전/오후 구분 및 시간 변환
  if (hours >= 12) {
    ampm = '오후'
    hours -= 12
  }
  if (hours === 0) {
    hours = 12
  }

  const minutes = date.getMinutes()

  // 날짜와 시간 조합하여 문자열 반환
  return `${year}-${padZero(month)}-${padZero(day)} ${ampm} ${padZero(hours)}:${padZero(minutes)}`
}

function formatDateToYYMMdd(date) {
  if (typeof date === 'string') {
    const year = date.substring(2, 4) // ex) 2023 -> 23
    const month = date.substring(4, 6)
    const day = date.substring(6, 8)

    return `${year}.${month}.${day}`
  }
}

function formatDateToYYYYMMdd(date) {
  if (typeof date === 'string') {
    const year = date.substring(0, 4) // ex) 2023 -> 23
    const month = date.substring(4, 6)
    const day = date.substring(6, 8)

    return `${year}-${month}-${day}`
  }
}

function getKoreanCurrentDate() {
  const today = new Date()
  const year = today.getFullYear()
  const month = today.getMonth() + 1 // 월은 0부터 시작하므로 +1 해줍니다.

  // 원하는 형식으로 날짜를 포맷합니다 (YYYY-MM 형식)
  const formattedDate = `${year}-${String(month).padStart(2, '0')}`

  return formattedDate
}

function getDates(startDate, endDate) {
  const dateArray = []
  const currentDate = new Date(startDate)

  while (currentDate <= new Date(endDate)) {
    dateArray.push(new Date(currentDate).toISOString().split('T')[0])
    currentDate.setDate(currentDate.getDate() + 1)
  }

  return dateArray
}

// 검체수거 알림 클릭 시 사용하는 현재 시간 구해주는 함수
function getCurrentTimeInSeoul() {
  const seoulTimezoneOffset = 9 * 60 // UTC+9 (서울의 시간대 오프셋, 분 단위)
  const now = new Date() // 현재 시간을 얻기 위한 Date 객체 생성
  const utc = now.getTime() + now.getTimezoneOffset() * 60000 // UTC 시간으로 변환 (분 단위)

  // 서울 시간으로 변환 (분 단위)
  const seoulTime = utc + seoulTimezoneOffset * 60000

  // 서울 시간을 기준으로 Date 객체 생성
  const seoulDate = new Date(seoulTime)

  // 시간을 얻어옴
  const hours = seoulDate.getHours()

  // 시간 형식에 맞게 문자열로 반환 (24시간 형식)
  const formattedTime = hours >= 10 ? `${hours}시` : `0${hours}시`
  return formattedTime
}

function getKoreanCurrentTime() {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours() % 12).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')
  const amOrPm = now.getHours() < 12 ? '오전' : '오후'

  const koreanTime = `${year}-${month}-${day} ${amOrPm} ${hours}:${minutes}:${seconds}`

  return koreanTime
}

// 숫자를 2자리 문자열로 변환하는 보조 함수
function padZero(number) {
  return String(number).padStart(2, '0')
}

function setTypeKey(item) {
  if (item.PushType === 'A01' || item.PushType === 'pushStore/mutionNewNotice' || item.pushType === 'pushStore/mutionNewNotice') {
    return 'newNotice'
  } else if (item.PushType === 'B01' || item.PushType === 'pushStore/mutationNewReqeust' || item.pushType === 'pushStore/mutationNewReqeust') {
    return 'newRequest'
  } else if (item.PushType === 'B10' || item.PushType === 'pushStore/mutationReqeustStatus' || item.pushType === 'pushStore/mutationReqeustStatus') {
    return 'newRequestStatus'
  } else if (item.PushType === 'C01' || item.PushType === 'pushStore/mutationnewIncongruity' || item.pushType === 'pushStore/mutationnewIncongruity') {
    return 'newIncongruity'
  } else if (item.PushType === 'C10' || item.PushType === 'pushStore/mutationIncongruityFeedBack' || item.pushType === 'pushStore/mutationIncongruityFeedBack') {
    return 'newIncongruityFeedBack'
  } else if (item.PushType === 'D01' || item.PushType === 'pushStore/mutationNewClient' || item.pushType === 'pushStore/mutationNewClient') {
    return 'newClient'
  } else if (item.PushType === 'D20' || item.PushType === 'pushStore/mutationNewClientConfirm' || item.pushType === 'pushStore/mutationNewClientConfirm') {
    return 'newClientConfirm'
  } else if (item.PushType === 'D30' || item.PushType === 'pushStore/mutationNewClientConfirmFinal' || item.pushType === 'pushStore/mutationNewClientConfirmFinal') {
    return 'newClientConfirmFinal'
  } else if (item.PushType === 'E01' || item.PushType === 'pushStore/mutationSpecimen' || item.pushType === 'pushStore/mutationSpecimen') {
    return 'newSpecimen'
  }
}

function convertCommasToBr(str) {
  if (typeof str === 'string') {
    return str.replace(/,/g, '<br/>')
  }
}

function isMobile() {
  const userAgent = window.navigator.userAgent
  if (/Android/i.test(userAgent)) {
    return true
  } else return /iPhone|iPad|iPod/i.test(userAgent)
}

function isIOS() {
  const user = window.navigator.userAgent
  return /iPhone|iPad|iPod/i.test(user)
}

function isAndroid() {
  const user = window.navigator.userAgent
  return /Android/i.test(user)
}

function getOSVersion() {
  const userAgent = navigator.userAgent.toLowerCase()

  function extractVersion(regex) {
    const match = userAgent.match(regex)
    return match ? match[1].replace(/_/g, '.') : 'Unknown'
  }

  if (userAgent.includes('android')) {
    const osVersion = extractVersion(/android\s([0-9\.]*)/)
    return `Android ${osVersion}`
  } else if (userAgent.includes('iphone')) {
    const osVersion = extractVersion(/os\s([\d_]*)/)
    return `iOS ${osVersion}`
  } else if (userAgent.includes('ipad')) {
    const osVersion = extractVersion(/os\s([\d_]*)/)
    return `iOS (iPad) ${osVersion}`
  } else if (userAgent.includes('windows')) {
    const osVersion = extractVersion(/windows\snt\s([\d\.]*)/)
    return `Windows ${osVersion}`
  } else if (userAgent.includes('mac os x')) {
    const osVersion = extractVersion(/mac\sos\sx\s([\d_\.]*)/)
    return `macOS ${osVersion}`
  }

  return 'Unknown OS'
}

function numberToDay(number) {
  let week = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
  if (typeof number === 'string') {
    let day = parseInt(number);
    if (day !== NaN) {
      return week[day - 1]
    }
    return "";
  } else {
    return "";
  }
}

function convertTo12HourFormat(time) {
  if (typeof time === 'string') {
    // 시간을 ':'로 분리하여 시와 분을 추출
    const [hourStr, minuteStr] = time.split(':');
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    // 오전/오후 판별
    let period = '오전';
    if (hour >= 12) {
      period = '오후';
      if (hour > 12) {
        hour -= 12;  // 13시 이상은 12를 빼서 12시간제로 변환
      }
    } else if (hour === 0) {
      hour = 12;  // 00시는 오전 12시로 변환
    }

    // 최종 포맷된 문자열 반환
    return `${period} ${hour}시 5분`;
  } else {
    return "";
  }
}

function splitStringEqually(str) {
  const middle = Math.floor(str.length / 2) // 가운데 인덱스 계산

  // 문자열 길이가 짝수인 경우
  if (str.length % 2 === 0) {
    return [str.substring(0, middle), str.substring(middle)]
  }

  // 문자열 길이가 홀수인 경우
  let firstHalf = str.substring(0, middle + 1) // 가운데 문자를 포함한 첫 번째 반절
  let secondHalf = str.substring(middle + 1) // 두 번째 반절

  // 두 번째 반절이 첫 번째 반절보다 길면 첫 번째 반절에 추가
  if (secondHalf.length > firstHalf.length) {
    firstHalf += secondHalf[0]
    secondHalf = secondHalf.substring(1)
  }

  return [firstHalf, secondHalf]
}

function splitStringIntoThree(str) {
  const partSize = Math.ceil(str.length / 3) // 올림 처리를 통해 최대한 글자 수가 맞도록 설정

  let firstPart = str.substring(0, partSize)
  let remainingStr = str.substring(partSize)

  // 남은 문자열 길이가 partSize보다 작으면 두 번째 파트에 추가
  let secondPart = remainingStr.length < partSize ? remainingStr : remainingStr.substring(0, partSize)
  let thirdPart = remainingStr.substring(partSize)

  return [firstPart, secondPart, thirdPart]
}


function addOneDay(dateStr) {
  // 입력된 날짜 문자열을 분리하여 연, 월, 일 정보를 얻음
  const [year, month, day] = dateStr.split('-').map(Number);

  // Date 객체 생성 (월은 0부터 시작하므로 -1 필요)
  const date = new Date(year, month - 1, day);

  // 하루 더함 (86400000 밀리초는 하루를 의미)
  date.setDate(date.getDate() + 1);

  // 연, 월, 일 정보를 얻음
  const newYear = date.getFullYear();
  const newMonth = (date.getMonth() + 1).toString().padStart(2, '0');
  const newDay = date.getDate().toString().padStart(2, '0');

  // YYYY-MM-dd 형식의 문자열로 반환
  return `${newYear}-${newMonth}-${newDay}`;
}

export {
  searchClientList,
  addPropertyToClientListDataObjects,
  numberToKorean,
  formatRegistrationNumber,
  formatNumberToRegexPattern,
  formatCelNumberToRegexPattern,
  formatDateTime,
  formatDateToYYMMdd,
  textWithLineBreaks,
  setTypeKey,
  convertCommasToBr,
  isMobile,
  isIOS,
  isAndroid,
  splitStringEqually,
  splitStringIntoThree,
  replaceCommasWithNewlines,
  getOSVersion,
  getKoreanCurrentDate,
  getKoreanCurrentTime,
  getDates,
  getCurrentTimeInSeoul,
  formatDateToYYYYMMdd,
  addOneDay,
  numberToDay,
  convertTo12HourFormat
}
